import React from "react";
import classNames from "classnames";
import { AnchorLinkIcon } from "@components/icons/anchorLinkIcon";
import * as c from "./faqs.module.scss";

const FaqAnchorLink = ({
  question,
  isCopied,
  onCopy,
  showCopiedText = true,
  noAnchorLinks = false,
  isMobile = false,
}) => {
  if (noAnchorLinks) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    onCopy();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      e.stopPropagation();
      onCopy();
    }
  };

  return (
    <div className={c.anchorContainer}>
      <div
        role="button"
        tabIndex={0}
        className={classNames(c.anchorLink, { [c.copied]: isCopied })}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        aria-label={`Copy link to "${question}"`}
      >
        <AnchorLinkIcon />
      </div>

      {showCopiedText && !isMobile && (
        <div className={classNames(c.copiedAnchor, { [c.visible]: isCopied })} aria-live="polite" data-nosnippet>
          Link copied
        </div>
      )}
    </div>
  );
};

export { FaqAnchorLink };
